/**
 * Hero Journey — Scroll-driven state transitions
 *
 * State changes are immediate and non-blocking.
 * CSS handles all visual transitions (opacity, transform).
 * Background images crossfade as complete planes; CSS respects reduced motion.
 */
(function () {
  var section = document.querySelector('.hero-journey');
  if (!section) return;

  var sticky = section.querySelector('.hero-journey__sticky');
  if (!sticky) return;

  var blockCount = parseInt(section.dataset.blockCount, 10) || 1;

  var bgLayers = section.querySelectorAll('.hero-journey__bg-layer');
  var contents = section.querySelectorAll('.hero-journey__content');
  var sideLabels = section.querySelectorAll('.hero-journey__side-label');
  var bgImages = section.querySelectorAll('.hero-journey__bg-layer img');
  var glow = section.querySelector('.hero-journey__glow');
  var scrollHint = section.querySelector('.hero-journey__scroll-hint');
  var liveStatus = section.querySelector('[data-hero-journey-status]');

  var currentState = 0;

  // Keep the transparent overlap tied to the visible header row. The global
  // header height can include an expanded mega menu during initial layout.
  function updateHeaderOffset() {
    var visibleHeader = document.querySelector('.section-header .header');
    if (!visibleHeader) return;
    document.documentElement.style.setProperty('--hero-header-height', visibleHeader.offsetHeight + 'px');
  }

  updateHeaderOffset();
  window.addEventListener('resize', updateHeaderOffset, { passive: true });
  window.addEventListener('load', updateHeaderOffset, { once: true });

  var visibleHeader = document.querySelector('.section-header .header');
  if (visibleHeader && 'ResizeObserver' in window) {
    new ResizeObserver(updateHeaderOffset).observe(visibleHeader);
  }

  // Mobile object-position handling
  var mobileQuery = window.matchMedia('(max-width: 767px)');
  function updateBgPositions() {
    var isMobile = mobileQuery.matches;
    bgImages.forEach(function (img) {
      if (img.tagName === 'IMG') {
        var pos = isMobile ? img.dataset.bgPositionMobile : img.dataset.bgPositionDesktop;
        if (pos) img.style.objectPosition = pos;
      }
    });
  }
  mobileQuery.addEventListener('change', updateBgPositions);
  updateBgPositions();

  /**
   * Set visual state immediately. No blocking, no timeouts for state logic.
   * CSS transitions handle the visual smoothness.
   */
  function setState(newState) {
    if (newState === currentState) return;
    currentState = newState;

    var isMoree = contents[newState] && contents[newState].dataset.isMoree === 'true';

    // Background layers (image + overlay) — toggle is-active
    for (var i = 0; i < bgLayers.length; i++) {
      bgLayers[i].classList.toggle('is-active', i === newState);
    }

    // Content layers
    for (var i = 0; i < contents.length; i++) {
      var isActive = i === newState;
      contents[i].classList.remove('is-exiting');
      contents[i].classList.toggle('is-active', isActive);
      contents[i].setAttribute('aria-hidden', String(!isActive));
      contents[i].inert = !isActive;
    }

    if (liveStatus && contents[newState]) {
      var activeHeading = contents[newState].querySelector('.hero-journey__heading');
      liveStatus.textContent = activeHeading ? activeHeading.textContent.trim() : '';
    }

    // Side labels
    for (var i = 0; i < sideLabels.length; i++) {
      sideLabels[i].classList.toggle('is-active', i === newState);
    }

    // Glow
    if (glow) {
      glow.classList.toggle('is-visible', isMoree);
    }

    // Scroll hint
    if (scrollHint) {
      scrollHint.classList.toggle('is-hidden', newState > 0);
    }

  }

  // Scroll-driven state tracking
  function onScroll() {
    var rect = section.getBoundingClientRect();
    var scrolled = -rect.top;
    var totalScroll = section.offsetHeight - window.innerHeight;
    if (totalScroll <= 0) return;

    var progress = Math.max(0, Math.min(1, scrolled / totalScroll));
    var targetState = Math.min(blockCount - 1, Math.max(0, Math.floor(progress * blockCount)));
    setState(targetState);
  }

  var ticking = false;
  function scheduleState() {
    if (!ticking) {
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', scheduleState, { passive: true });
  window.addEventListener('resize', scheduleState, { passive: true });

  // Initial state
  onScroll();

  // === Transparent header overlay ===
  var transparentEnabled = section.dataset.transparentHeader === 'true';
  if (transparentEnabled) {
    var heroSection = document.getElementById('HeroJourney-' + section.dataset.sectionId);
    var heroVisible = true;
    var megaMenuIsOpen = false;

    function updateTransparentHeader() {
      var shouldBeTransparent = heroVisible && !megaMenuIsOpen;
      document.documentElement.classList.toggle('transparent-header', shouldBeTransparent);
    }

    var headerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        heroVisible = entry.isIntersecting;
        updateTransparentHeader();
      });
    }, { threshold: 0 });

    if (heroSection) {
      headerObserver.observe(heroSection);
    }

    // Mega menu interaction: instant remove, crossfade restore
    document.addEventListener('mega-menu:open', function () {
      megaMenuIsOpen = true;
      // Instant swap: suppress transition
      var hw = document.querySelector('.header-wrapper');
      if (hw) {
        hw.classList.add('no-transition');
        // Force reflow so no-transition takes effect before class removal
        void hw.offsetHeight;
      }
      updateTransparentHeader();
      // Re-enable transitions after a tick
      if (hw) {
        requestAnimationFrame(function () {
          hw.classList.remove('no-transition');
        });
      }
    });

    document.addEventListener('mega-menu:close', function () {
      megaMenuIsOpen = false;
      updateTransparentHeader();
    });
  }
})();

